import React, { useEffect, useRef } from "react";
import "./css/Team.css";

const teamMembers = {
  management: [
    {
      name: "Shishir Singh ",
      role: "Founder, MD & CEO",
      image: "shishirPNG.png",
      extras: [
        "National Startup Cohort Winner at Nasscom Foundation",
        "JEE Advance Qualified",
      ],
    },
  ],
  directors: [
    {
      name: "Adarsh Kumar",
      role: "Director",
      image: "Adarsh.png",
      extras: ["JEE Advanced Qualified"],
    },
    {
      name: "Anshu Raj",
      role: "Director",
      image: "Anshu-pic.png",
      extras: ["JEE Advanced Qualified"],
    },
  ],
  others: [
    {
      name: "Sakshi Semiwal",
      role: "UI/UX (Bachelor Of Design)",
      image: "sakshi2.png",
    },
  ],
  mentors: [
    { name: "Pallav", role: "Tech Mentor (IIT Delhi)", image: "pallav.jpg" },
    {
      name: "Arunima",
      role: "Finance and B2B Mentor (IIM Ahmedabad)",
      image: "arunima.jpg",
    },
    {
      name: "Muskan Gupta",
      role: "Social Initiatives Mentor",
      image: "Muskan.jpg",
    },
  ],
};

const TeamSection = ({ title, members }) => (
  <div className="team-section">
    <h3>{title}</h3>
    <div className="team-grid">
      {members.map((member, index) => (
        <div
          className={`team-card ${
            member.name === "Adarsh Kumar" ? "adarsh-card" : ""
          }`}
          key={index}
        >
          <img
            src={member.image}
            alt={member.name}
            className={`${
              member.name === "Adarsh Kumar" ? "adarsh-image" : "team-image"
            }`}
          />
          <h3>{member.name}</h3>
          <p>{member.role}</p>
          {member.extras && member.extras.map((t, ind) => <p key={ind}>{t}</p>)}
        </div>
      ))}
    </div>
  </div>
);

const TeamSection2 = ({ title, members }) => (
  <div className="team-section">
    <h3>{title}</h3>
    <div className="team-grid">
      {members.map((member, index) => (
        <div
          className={`team-card ${
            member.name === "Adarsh Kumar" ? "adarsh-card" : ""
          }`}
          key={index}
        >
          <img
            src={member.image}
            alt={member.name}
            className={`${
              member.name === "Adarsh Kumar" ? "adarsh-image" : "team-image"
            }`}
          />
          <h3>{member.name}</h3>
          <p>{member.role}</p>
        </div>
      ))}
    </div>
  </div>
);

const Team = () => {
  const sectionRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
          observer.unobserve(entry.target);
        }
      });
    });

    sectionRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="team-container">
      <h2>Meet Our Team</h2>
      {Object.keys(teamMembers).map((section, idx) => {
        return (
          <div
            className="team-wrapper"
            ref={(el) => (sectionRef.current[idx] = el)}
            key={section}
          >
            <TeamSection
              title={section.charAt(0).toUpperCase() + section.slice(1)}
              members={teamMembers[section]}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Team;
